;
define("transaction_line_views_price.tpl", function(){});

